import { useState, useEffect } from "react";
import Dashboard from "./Dashboard";
//import NotificationManager from "react-notifications";
import axios from "axios";
import React from "react";
import InvalidAccess from "./InvalidAccess";
import { toast } from 'react-toastify';
export default function Reports() {
  let newDate = new Date();
  let tabcount = 0;
  const corp_id = localStorage.getItem("business_id");
  const user_id = localStorage.getItem("user");
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
const qstatus = [
    { value: "quoted", label: "Quoted" },
    { value: "follow_up", label: "Follow Up" },
    { value: "negotiation", label: "Negotiation" },
    { value: "revised", label: "Revised Quote" },
    { value: "approved", label: "Approved" },
    { value: "invoiced", label: "Invoiced" },
    { value: "closed", label: "Closed" },
    { value: "lost_price", label: "Lost - Price" },
    { value: "lost_competitor", label: "Lost - Competitor" },
    { value: "lost_notavailable", label: "Lost - Not Available" },
    { value: "not_required", label: "Not Required" },
    { value: "cancelled", label: "Cancelled" },
  ];  
  const getOrgMem =({
    cusID: 0,
    corp_id: corp_id,
    user_id: user_id,
    module: "getOrgMem",
    product: "quotationB",
  });
const ryts = localStorage.getItem("user_rights");
  const [reportfor, setReportFor] = useState({
    to: "",
    from: "",
    user_id: localStorage.getItem("user"),
    corp_id: localStorage.getItem("business_id"),
    module: "forReport",
    product: "quotationB",
  });
  const [filters, setFilters] = useState({
  representative: "all",
  qstatus: "all",
});
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters((prev) => ({
    ...prev,
    [name]: value,
  }));
};
  const [reportData, setReportData] = useState([
    {
      id: 0,
      name: "",
      status: 0,
      customer: "",
      comment: "",
      date_entered: "",
      user: "",
      total: "",
    },
  ]);
  const [orgMembers, setOrgMembers] = useState([{id:0, name:""}]);
  const generatePDF = (pdfID) => {
    localStorage.setItem("generatePDF", pdfID);
    window.open("../pdfr");
  };
  async function AxiosReport(formData) {
    //NotificationManager.info("please wait...");
    JSON.stringify(formData);
    axios({
      method: "post",
      url: "https://www.qb.avilashcorp.com/reactManager/",
      data: formData,
    }).then((res) => {
      if(res.data!=null){
        if(formData.module=="getOrgMem" && res.data.data!=undefined){
          setOrgMembers(res.data.data);
        }
      if (formData.module === "forReport") {
        setReportData(res.data.data);
      }}else{
        toast.warning("no result found!");
      }
      if(formData.module === "manageQStatus"){
        if(res.data.includes("record upd")){
          const newdata = reportData.map((rData)=>{
            return (rData.id==formData.id) ? {...rData,['status']:2} : {...rData} ;
          });
          setReportData(newdata);
        }
      }
    });
  }
  
  const handleOnchange = (event) => {
    const { name, value } = event.target;
    setReportFor({ ...reportfor, [name]: value });
  };


  const convertPI = (event) =>{
    if(window.confirm("are you sure you want to generate P.I.?")){
    const udtVal = (event.target.checked) ? 2 : 1 ;
    const quoteInitial = {
      id: event.target.value,
      status:udtVal,
      corp_id: corp_id,
      module: "manageQStatus",
      product: "quotationB",
    };
    AxiosReport(quoteInitial);
    // toast.info();
    }
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    AxiosReport(reportfor);
  };
  
  useEffect(() => {
      AxiosReport(getOrgMem);
    }, []);

  if (
    localStorage.getItem("user") === 20000 ||
    localStorage.getItem("user") === ""
  ) {
    return <InvalidAccess />;
  }
  return (
    <>
      <Dashboard />
      <div id="content_area">
        <h2>Reporting Sales</h2>
        <form onSubmit={handleSubmit} method="post">
        <div style={{ margin: "15px 0", display: "flex", gap: "15px" }}>
          <select
            name="representative"
            value={filters.representative}
            onChange={handleFilterChange}
          >
            <option value="all">All Representatives</option>
            {orgMembers.map((orgM) => (
              <option key={orgM.id} value={orgM.name}>
                {orgM.name}
              </option>
            ))}
          </select>

          <select
            name="qstatus" value={filters.qstatus} onChange={handleFilterChange}>
            <option value="all">All Status</option>
            {qstatus.map((status) => (
              <option key={status.value} value={status.value}>
                {status.label}
              </option>
            ))}
          </select>

        </div>
          <input
            type="date"
            required
            name="from"
            onChange={handleOnchange}
            max={year + "-" + month + "-" + date}
            style={{ width: "135px", float: "left" }}
          />
          <input
            type="date"
            required
            name="to"
            onChange={handleOnchange}
            max={year + "-" + month + "-" + date}
            style={{ width: "135px", float: "left" }}
          />
          <input
            type="submit"
            name="generate"
            value={"Generate"}
            style={{ width: "135px", float: "left", textAlign: "center" }}
          />
        </form>
        <table className="quoteTable">
          <thead>
          <tr>
            <td>#</td>
            <th>Customer</th>
            <th>Quote Name</th>
            <th>Representative</th>
            <th>Taxable</th>
            <th>Q Status</th>
            <th>P.I.</th>            
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          {reportData
            .filter((quote) => {
              const repMatch =
                filters.representative === "all" ||
                quote.user === filters.representative;
              const statusMatch =
                filters.qstatus === "all" ||
                quote.qstatus == filters.qstatus;
              return repMatch && statusMatch;
            })
            .map((quote) => {
            const stt = (quote.status==2) ? true : false ;
            tabcount++;
            return quote.name === "" || (ryts==3 && !stt ) ? (
              ""
            ) : (
              <tr key={quote.id}>
                <td>{tabcount}</td>
                <td>{quote.customer}</td>
                <td>{quote.name}<small><br />({quote.date_entered})</small></td>
                <td>{quote.user}</td>
                <td>{quote.total}</td>
                <td>{quote.qstatus}</td>
                <td>
                  <input type="checkbox" name="status" value={quote.id} onChange={convertPI} checked={stt} disabled={stt} />
                </td>
                <td>
                  <button
                    onClick={() => {
                      generatePDF(quote.id);
                    }}
                  >
                    generate pdf
                  </button>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </>
  );
}
